// src/components/LoginPage.jsx
import React, { useEffect, useState } from "react";

import { loginRequest } from "../api/auth";
import companyLogo from "../assets/aei-logo.jpg";

function LoginPage({ onLogin, onShowRegister }) {
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);

useEffect(() => {
  const msg = sessionStorage.getItem("aei_login_message");
  const reason = sessionStorage.getItem("aei_login_reason");

  if (msg === "SESSION_EXPIRED") {
    setStatusMessage("Your session has expired. Please log in again.");
  } else if (msg === "LOGGED_OUT") {
    setStatusMessage("You were logged out. Please log in again.");
  }

  // ✅ DO NOT remove sessionStorage here (StrictMode runs effect twice)
}, []);





 const handleSubmit = async (e) => {
  e.preventDefault();
  setStatusMessage("");
  setLoading(true);

  try {
    const result = await loginRequest({
      email: emailOrUsername,
      password,
    });

   if (result.accessToken && result.user) {
  try {
    sessionStorage.removeItem("aei_login_message");
    sessionStorage.removeItem("aei_login_reason");
  } catch (e) {}

  await onLogin(result);
} else {
  setStatusMessage("Unexpected response from server.");
}
  } catch (err) {
    console.error("Login error:", err);
    const response = err?.response;
    const data = response?.data || {};

    const msg =
      data.error ||
      data.message ||
      "Login failed. Please check your credentials.";

    setStatusMessage(msg);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="auth-layout">
      {/* Top bar */}
      <header className="app-header">
        <div className="app-header-left">
          <img
  src={companyLogo}
  alt="AEI Progetti"
  className="app-header-logo-small"
  width="140"
  height="50"
/>

          <div>
            <div className="app-header-company">AEI PROGETTI SRL</div>
            <div className="app-header-tagline">Engineering Software Suite</div>
          </div>
        </div>
      </header>

      {/* Centered login card */}
      <main className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <img src={companyLogo} alt="AEI Progetti" width="140" height="50" />

          </div>

          <h1 className="auth-title">Login</h1>
          <p className="auth-subtitle">
            Use your AEI account to access the tools.
          </p>

          {statusMessage && (
            <div className="status-message">{statusMessage}</div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            {/* Username / Email field */}
            <div className="form-field">
              <label className="form-label" htmlFor="login-identifier">
                Username or Email
              </label>
              <input
                id="login-identifier"
                className="form-input"
                type="text"
                autoComplete="username"
                value={emailOrUsername}
                onChange={(e) => setEmailOrUsername(e.target.value)}
                required
              />
            </div>

            {/* Password field */}
            <div className="form-field">
              <label className="form-label" htmlFor="login-password">
                Password
              </label>
              <input
                id="login-password"
                className="form-input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {/* Login button */}
            <button
              type="submit"
              className="primary-button"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          {/* Register link */}
          <div className="auth-footer">
            <span>Don&apos;t have an account?</span>
            <button
              type="button"
              className="link-button"
              onClick={onShowRegister}
            >
              Register
            </button>
          </div>
        </div>
      </main>

      {/* Footer with company info */}
      <footer className="site-footer">
        <div className="site-footer-inner">
          <div className="site-footer-section site-footer-logo">
            <img src={companyLogo} alt="AEI Progetti" />
            <div>
              <strong>AEI PROGETTI SRL</strong>
              <br />
              Via Bolognese 48
              <br />
              50139 Firenze, Italy
            </div>
          </div>

          <div className="site-footer-section">
            <div>Phone: +39 055 400714</div>
            <div>Fax: +39 055 461079</div>
          </div>

          <div className="site-footer-section">
            <div>Email: mail@aeiprogetti.it</div>
            <div>PEC: mail@pec.aeiprogetti.it</div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LoginPage;
